/**
 * BattleTabs — new-tab game
 *
 * Declares a single web-accessible-resource entry — `newtab.html` — with no
 * `use_dynamic_url`, but matched only to three origins: a localhost dev server, the
 * staging Pages deployment, and the production site `https://battletabs.io`. It is not
 * exposed to arbitrary pages, so a fetch from anywhere else fails at the network layer
 * and says nothing about whether the extension is installed.
 *
 * From battletabs.io the static URL resolves whenever the extension is present, which
 * makes it a conclusive signal for that one origin.
 *
 * Manifest verified against version 52.25.0.3427.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mjcklhnhfiepmofggcoegkmkokbljmjd';

export const battleTabs: ExtensionDefinition = {
  id: ID,
  name: 'BattleTabs',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://battletabs.io',
  notes:
    'One static WAR (newtab.html) scoped to battletabs.io (plus a localhost dev server ' +
    'and a staging origin), so only battletabs.io can detect it. No dynamic URL.',
  signals: [
    {
      id: 'war-newtab-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch newtab.html — the static new-tab page, exposed only to battletabs.io and ' +
        'its dev/staging origins. Reachable at a fixed URL when installed.',
      weight: 1,
      run: () => probeFetch(ID, 'newtab.html'),
    },
  ],
};
